module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rLzrh8/tc-custom/FC-9781643780085.jpg?1685204506029?1709061805485",
      "alt": "This image is the cover for the book The Sex Coach"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Sex Coach\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A twisted modern love story. After ending a long and difficult conventional marriage, middle-aged Sarah craves challenge—and fun. But who is she? Is she desirable? A plunge into online dating quickly finds Sarah entangled with the evasive and compelling Rick. Their online chat transcripts relive and anticipate not only their own trysts but her experiences with other lovers. Pushing her sexual boundaries, Rick advises and encourages Sarah to report back in detail. He assures Sarah this is therapeutic, dubbing himself as her ‘sex coach’. Against these secret sexual exploits, Sarah shares the lonely reality of day-to-day survival as a single older woman, coping with the fraught dynamics of family and friends. But what is Rick’s agenda? Is he capable of helping Sarah make good choices? What is he coaching her towards? Immersive, stimulating and engaging, The Sex Coach is more than an exciting insight into the precarious and intriguing world of online dating.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane McLeod\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jane McLeod was born in 1960 in Auckland, New Zealand, where she has lived most of her life. The inspiration for The Sex Coach came from various conversations about separation with other women, all of whom described a difficult adjustment for family and friends, and some had experienced a period of sexual exploration and freedom. This is Jane’s first novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0